import { createRoot } from 'react-dom/client'

import App from './App.tsx'
import { loadCatalog } from './services/devices/setup'
import { SentryService } from './services/SentryService'
import './index.css'

SentryService.initialize()

// The device catalog saved on this PC, so printing works before (or without) the next sync.
loadCatalog().catch(() => undefined)

createRoot(document.getElementById('root')!).render(<App />)

// Production only: in development the service worker would serve stale modules.
if (import.meta.env.PROD && 'serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').catch((error) => console.warn('[pos] service worker', error))
  })
}

// Unsynced sales live in IndexedDB; ask the browser not to evict it under storage pressure (§15.10 item 6).
navigator.storage?.persist?.().catch(() => undefined)
